<template>
  <div class="gs-aff-panel">
    <header class="gs-aff-panel__head">
      <div>
        <h3>Affiliate registration integrations</h3>
        <p>When someone registers as an affiliate for this product, add them to a list or tag in your connected tools.</p>
      </div>
      <gs-button
        v-if="canAddIntegration"
        type="button"
        variant="primary"
        size="sm"
        @click="showAffiliateRegistrationIntegrationBox()"
      >
        <gs-icon name="plus" size="14"></gs-icon>
        {{ $t('frontend_product_step9_add_new_integration') }}
      </gs-button>
    </header>

    <div v-if="!canAddIntegration" class="gs-aff-empty">
      <strong>No integrations connected</strong>
      <p>{{ $t('frontend_product_step9_no_integrations_added') }}</p>
    </div>

    <div v-else-if="integrations.length === 0" class="gs-aff-empty">
      <strong>No registration integrations yet</strong>
      <p>{{ $t('frontend_product_step9_no_integrations') }}</p>
      <gs-button type="button" variant="outline" size="sm" @click="showAffiliateRegistrationIntegrationBox()">
        <gs-icon name="plus" size="14"></gs-icon>
        {{ $t('frontend_product_step9_add_new_integration') }}
      </gs-button>
    </div>

    <div v-else class="gs-aff-list">
      <article
        v-for="(integration, integrationIndex) in integrations"
        :key="integrationIndex"
        class="gs-aff-row is-configured"
      >
        <div class="gs-aff-row__head gs-aff-row__head--static">
          <span class="gs-aff-row__dot" aria-hidden="true"></span>
          <span class="gs-aff-row__title">
            <span class="gs-aff-row__name">{{ platformName(integration.platform) }}</span>
            <span class="gs-aff-row__summary">{{ $t('frontend_groovesell_addTo') }} {{ configSummary(integration) }}</span>
          </span>
          <span class="gs-aff-row__meta">
            <span class="gs-aff-pill gs-aff-pill--success">On registration</span>
          </span>
          <gs-button
            type="button"
            variant="ghost"
            size="sm"
            class="is-destructive"
            :aria-label="$t('frontend_groovesell_delete_integration')"
            :title="$t('frontend_groovesell_delete_integration')"
            @click="deleteAffiliateRegistrationIntegration(integrationIndex)"
          >
            <gs-icon name="trash" size="16"></gs-icon>
          </gs-button>
        </div>
        <div v-if="(integration.config || []).length" class="gs-aff-row__body gs-aff-row__body--flat">
          <div class="gs-aff-details">
            <div v-for="(config, configIndex) in integration.config" :key="configIndex">
              <small>{{ config.label }}</small>
              <strong :title="config.name">{{ config.name }}</strong>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    validation: {
      required: true
    },
    showAffiliateRegistrationIntegrationBox: {
      type: Function,
      required: true
    },
    deleteAffiliateRegistrationIntegration: {
      type: Function,
      required: true
    },
    pluginSiteData: {
      required: true
    },
    availableIntegrations: {
      required: true
    }
  },
  watch: {
    model: {
      handler() {
        this.$emit('update-model', this.localModel);
      },
      deep: true
    }
  },
  data() {
    return {
      localModel: this.model,
    };
  },
  computed: {
    canAddIntegration() {
      const connected = this.pluginSiteData && this.pluginSiteData.integrations;
      return Boolean(connected && connected.length > 0 && this.availableIntegrations && this.availableIntegrations.length > 0);
    },
    integrations() {
      return this.localModel.affiliate_registration_integrations || [];
    },
  },
  methods: {
    platformName(platform) {
      const value = String(platform || 'Integration');
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    configSummary(integration) {
      const names = (integration.config || []).map((config) => config.name).filter(Boolean);
      return names.length ? names.join(' · ') : 'configured list';
    },
  },
};
</script>
